import * as enums from '@local/finsera-core/src/enums';
import { _ } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

const getNewData = (data: types.widgets.TableData, selectedPeriod: enums.PERIOD_ENUM, xAxisField: string) => {
  const newData = data.map((row: types.widgets.TableData[0]) => {
    const periods = Object.values(enums.PERIOD_ENUM) as string[];
    const newRow = {} as types.widgets.TableData[0];

    Object.keys(row).forEach((key: string) => {
      if (selectedPeriod === enums.PERIOD_ENUM.FULL) {
        // FULL can be represented in 2 ways:
        // 1. Keys that don't start with any period (original data without period prefix)
        // 2. Keys that start with "FULL_" prefix
        if (!periods.some((period) => key.startsWith(period)) || key.startsWith(enums.PERIOD_ENUM.FULL)) {
          const cleanKey = key.startsWith(enums.PERIOD_ENUM.FULL) ? key.slice(enums.PERIOD_ENUM.FULL.length + 1) : key;
          newRow[cleanKey] = row[key];
        }
      } else {
        if (key.includes(selectedPeriod)) {
          newRow[key.slice(selectedPeriod.length + 1)] = row[key];
        }
      }
      newRow[xAxisField] = row[xAxisField];
    });
    return newRow;
  });

  // Find first non-null data point across all datapoints
  let firstValidIndex = 0;
  const seriesData = _.sortBy(newData, xAxisField);
  const dataKeys = _.without(Object.keys(seriesData?.[0] ?? {}), xAxisField);
  for (let i = 0; i < seriesData.length; i++) {
    const oneHaveValue = _.some(dataKeys, (key) => !_.isNil(seriesData[i]?.[key]));
    if (oneHaveValue) {
      firstValidIndex = i;
      break;
    }
  }
  if (firstValidIndex === 0 && _.isEmpty(_.without(Object.keys(seriesData[0] ?? {}), xAxisField))) return [];
  return seriesData.slice(firstValidIndex);
};

export const getPeriodData = ({
  data,
  xAxisField,
  forceSameStart = false,
}: {
  data: types.widgets.TableData;
  xAxisField: string;
  forceSameStart: boolean;
}) => {
  const availablePeriods = [] as enums.PERIOD_ENUM[];
  const allData = {} as Record<enums.PERIOD_ENUM, types.widgets.TableData>;
  Object.values(enums.PERIOD_ENUM).map((key) => {
    allData[key] = getNewData(data, key, xAxisField);

    if (!_.isEmpty(allData?.[key])) {
      if (!forceSameStart) availablePeriods.push(key);
      // If we don't have all values set (not undefined or null) on first position then it is not an available period
      else if (Object.values(allData?.[key]?.[0] ?? {}).every((value) => value != null)) availablePeriods.push(key);
    }
  });

  return {
    allData,
    availablePeriods,
  };
};
